import React from "react"
import {Grid} from "react-bootstrap"
import {RouteComponentProps} from "react-router-dom"

import {Card} from "@irati/ui/src/Layout"
import Spacing from "@irati/ui/src/Spacing"
import DealByUrlSlug from "@irati/deals/apollo/query/DealByUrlSlug"
import {DealContextProvider} from "@irati/deals/hooks/useDeal"
import RequireDealStatusOn from "@irati-web/perks/src/components/RequireDealStatusOn"
import DealBanner from "@irati-web/perks/src/components/DealBanner"
import DealHeader from "@irati-web/perks/src/components/Deal/Header"
import DealDescription from "@irati-web/perks/src/components/Deal/Description"
import DealFAQ from "@irati-web/perks/src/components/Deal/FAQ"
import DealDeliveryInfo from "@irati-web/perks/src/components/Deal/DeliveryInfo"
import ContactInfo from "@irati-web/perks/src/components/Deal/ContactInfo"
import MobileFlushCol from "@irati-web/perks/src/components/ui/MobileFlushCol"
import DealHowItWorks from "@irati-web/perks/src/components/Deal/HowItWorks"
import ImportantInfo from "@irati-web/perks/src/components/DealImportantInfo/ImportantInfo"
import tracking from "@irati-tracking/perks/perks"

interface Props extends RouteComponentProps<{benefitUrlSlug: string}> {
  id?: string
}

export const LocalBenefitLandingScreen: React.FC<Props> = (props) => {
  const urlSlug = props.match.params.benefitUrlSlug

  return (
    <DealByUrlSlug variables={{urlSlug}} Error={RequireDealStatusOn}>
      {({data}) => {
        if (!data || !data.dealBySlug) {
          return <RequireDealStatusOn deal={null} />
        }
        const deal = data.dealBySlug
        tracking.viewPerk(deal, "local_benefits", "homepage")

        return (
          <DealContextProvider deal={deal}>
            <DealBanner deal={deal} />

            <Grid>
              <Spacing marginTop="75px">
                <MobileFlushCol xs={12}>
                  <Card>
                    <DealHeader deal={deal} />
                    <DealDescription deal={deal} />
                    <DealHowItWorks deal={deal} />
                    <DealDeliveryInfo deal={deal} />
                    <ImportantInfo data={deal.importantInfo} />
                    <DealFAQ deal={deal} />
                    <ContactInfo deal={deal} />
                  </Card>
                </MobileFlushCol>
              </Spacing>
            </Grid>
          </DealContextProvider>
        )
      }}
    </DealByUrlSlug>
  )
}
